import { render, staticRenderFns } from "./IsimCategory.vue?vue&type=template&id=59b4cac8&scoped=true"
import script from "./IsimCategory.vue?vue&type=script&lang=js"
export * from "./IsimCategory.vue?vue&type=script&lang=js"
import style0 from "./IsimCategory.vue?vue&type=style&index=0&id=59b4cac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4cac8",
  null
  
)

export default component.exports